export const ALLOWED_DOMAIN = 'Allowed';
export const BLOCKED_DOMAIN = 'Blocked';
